/**
 * Zoom slot component.
 */
export const Zoom = () => null;

Zoom['displayName'] = 'Zoom';
